import { createAsyncThunk } from '@reduxjs/toolkit';
import { PatientsActions } from 'application/constants/actions';
import { AxiosError } from 'axios';
import { PatientsApi } from 'integration/api/patients';
import { fetchPatientsProps } from 'common/types/patients';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Fetches patients data from the API
 *
 * @param params - Object containing query parameters for fetching patients data
 * @returns An object representing the fetched patients data or an error message if fetching fails
 */
export const fetchPatients = createAsyncThunk(
  PatientsActions.fetchPatients,
  async (params: fetchPatientsProps, { rejectWithValue }) => {
    try {
      const { data: responseData } = await PatientsApi.fetchPatients(params);

      await delay(1000);

      return responseData;
    } catch (e) {
      const error = e as AxiosError;
      return rejectWithValue(error.message);
    }
  },
);
